<div *ngIf="lottoItem; else noPurchase" class="container pt-30">
  <div class="success-content">
    <div class="success-message">
      <div>
        <p class="text-success mb-0 font-heading font-size-18">
          {{ 'lotto.entry.successful' | translate }}
        </p>
        <p class="mb-0 text-black font-size-14">
          <ng-container>{{ 'lottos.purchase.confirm' | translate }}</ng-container>
        </p>
      </div>
      <a class="btn btn-primary confirm-btn font-heading" [routerLink]="['/rewards/wallet']">
        {{ 'rewards.back.to.wallet' | translate }}
      </a>
    </div>

    <div class="payment-details d-flex flex-wrap">
      <div class="image-wrap">
        <img
          class="purchase-success-image"
          src="{{ lottoItem.ImageName | contentImage : '6' : 'lotto' }}"
          alt="{{ lottoItem.Title }}"
          [useDefault]="true"
          loyaltyType="marketplace"
          draggable="false"
        />
      </div>
      <div class="purchase-details">
        <div class="font-size-14 font-heading purchase-summary-name first-text-capitalize">
          {{ lottoItem.Title }}
        </div>
        <div class="purchase-summary-rows">
          <div class="purchase-summary-row">
            <span class="font-size-12 rewards-details-spacing">{{ 'lotto.entries' | translate }}</span>
            <span class="font-heading font-size-14">{{ quantity }}</span>
          </div>
          <div class="purchase-summary-row">
            <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.points.value' | translate }}</span>

            <span *ngIf="totalPrice > 0" class="font-heading font-size-14"
              >{{ totalPrice | number }} {{ 'marketplace.points.value.pts' | translate }}</span
            >
            <span *ngIf="totalPrice == 0" class="font-heading font-size-14">
              {{ 'fgbcl.marketplace.item.free' | translate }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noPurchase>
  <div class="text-center m-5">{{ 'no.purchased.item.found' | translate }}</div>
</ng-template>
